import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/DashboardStats.jsx");
